import React from 'react';
import { IMaskMixin } from 'react-imask';
import { Input } from './Input';
// !important: md: use onAccept instead of changeHandler
// https://github.com/uNmAnNeR/imaskjs/issues/318
export const InputMasked = IMaskMixin(({ inputRef, ...props }) => (React.createElement(Input, { ...props, ref: inputRef })));
